import script from "./SwitchCardsTableView.vue?vue&type=script&setup=true&lang=js"
export * from "./SwitchCardsTableView.vue?vue&type=script&setup=true&lang=js"

import "./SwitchCardsTableView.vue?vue&type=style&index=0&id=b96ff9d0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b96ff9d0"]])

export default __exports__